<header>
  <!-- Get TYT on the go! -->
  {{ title }}
</header>
<summary>
  Download the app
</summary>

<a target="_blank" href="http://join.tyt.com/app/">
  <div class="image-preview" responsiveBackgroundImage="/assets/tyt-mobile-upsell.png">
  </div>
</a>

<hr/>

<div class="store-links">
    <a target="_blank" href="https://itunes.apple.com/us/app/tyt-plus-news-entertainment/id1319576607?mt=8">
      <img class="apple" src="/assets/appstore/apple/black.svg" />
    </a>
    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.tyt.battlecruiser&hl=en_US">
      <img src="/assets/appstore/google/black.png" />
    </a>
</div>
